<template>
  <div class="circles">
    <div class="container">
      <div class="row">
        <div class="col-xs-12 circles__line">
          <div v-for="category of visibleCategories" :key="category.id" class="circles__box secondary-font">
            <router-link
              class="nav-link no-underline circles__link"
              :to="categoryLink(category)"
            >
              <img
                v-lazy="thumbnail(category.cate_landing_img)"
                alt="zdjecie kategorii" width="160px"
                height="160px" class="circles__image"
              >
              <span class="circles__text cl-black">{{ category.name }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from 'config'
import { mapGetters } from 'vuex'
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import groupBy from 'lodash-es/groupBy'
import { getThumbnailCategoryPath as _thumbnailHelper } from '@vue-storefront/core/helpers'

export default {
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters('category-next', ['getMenuCategories']),
    categoriesMap () {
      return groupBy(this.getMenuCategories, 'parent_id')
    },
    visibleCategories () {
      return this.categoriesMap[config.server.mainCategoryId]
    }
  },
  methods: {
    thumbnail (src) {
      return this.getThumbnail(src, 160, 160, 'category')
    },
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>

<style lang="scss" scoped>
.circles {
  background-color: white;
  @media (max-width: 767px) {
    background-color: unset;
  }
  &__line {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    @media (max-width: 767px) {
      padding-top: 50px;
      padding-bottom: 50px;
    }
    margin-bottom: 20px;
    display:inline-flex;
    justify-content: space-between;
    padding-top: 100px;
    padding-bottom: 80px;
  }
  &__link {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    -ms-flex-direction: column;
    padding-left: 30px;
    padding-right: 30px;
  }
  &__image {
    @media (max-width: 767px) {
      width: 140px;
      height: 140px;
    }
    object-fit: cover;
    object-position: left center;
    background-color: rgb(204, 204, 204);
    border-radius: 50%;
  }
  &__text {
    @media (max-width: 767px) {
      margin-top: 20px;
    }
    margin-top: 40px;
    text-align: center;
  }
}
</style>
